import {Button} from '@mantine/core';
import {useCallback} from 'react';
import {useActiveEditMode, useStartAddPlayer} from '../state/networkEditStore';

export const AddPlayerButton = () => {
    const activeEditMode = useActiveEditMode();
    const startAddPlayer = useStartAddPlayer();
    const isAddPlayerMode = activeEditMode === 'addPlayer';

    const addPlayer = useCallback(() => {
        startAddPlayer();
    }, [startAddPlayer]);
    
    return <>
        <Button
            data-testid={'addPlayerButton'}
            style={{pointerEvents: 'all'}}
            disabled={isAddPlayerMode}
            variant={isAddPlayerMode ? 'filled' : 'inherit'}
            color={isAddPlayerMode ? 'red' : 'inherit'}
            onClick={addPlayer}>Add Player</Button>
    </>;
};
